<template>
  <div>
    <div>
      <div>
        <div class="modal-header text-center">
          <h4 class="modal-title w-100 font-weight-bold">Editar Municipio</h4>
        </div>

        <form>
          <div class="modal-body mx-3">
            <div class="md-form form-sm">
              <label for="municipio">Município:</label>
              <select
                class="form-control"
                id="municipio"
                v-model="payload.municipioId"
                @change="municipioChange"
                required
              >
                <option
                  v-for="municipio in municipios"
                  v-bind:value="municipio.municipioId"
                  v-bind:key="municipio.municipioId"
                >
                  {{ municipio.nome }}
                </option>
              </select>
            </div>

            <div class="md-form">
              <i class="fas fa-user prefix grey-text"></i>
              <label data-error="wrong" data-success="right" for="inicioString"
                >Nome:</label
              >
              <input
                type="text"
                id="nome"
                class="form-control validate"
                v-model="payload.nomeContato"
              />
            </div>

            <div class="md-form">
              <i class="fas fa-user prefix grey-text"></i>
              <label data-error="wrong" data-success="right" for="termino"
                >E-mail:</label
              >
              <input
                type="email"
                id="email"
                class="form-control form-control-sm validate"
                v-model="payload.emailContato"
                required
              />

              <div class="md-form">
                <i class="fas fa-user prefix grey-text"></i>
                <label data-error="wrong" data-success="right" for="link"
                  >Telefone celular com DDD:</label
                >
                <input
                  type="text"
                  id="link"
                  class="form-control validate"
                  v-model="payload.telefoneContato"
                  v-mask="'(##) #####-####'"
                  required
                />
              </div>
            </div>

            <div class="modal-footer d-flex justify-content-center">
              <p>
                <button
                  class="btn btn-info"
                  style="height: unset; align-items: center"
                  type="submit"
                  @click="cadastrar"
                >
                  Atualizar
                </button>
              </p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { municipioAPI } from "@/modules/home";
export default {
  data() {
    return {
      municipios: [],
      payload: {
        nomeContato: "",
        emailContato: "",
        telefoneContato: "",
        municipioId: null,
        temEdital: "",
        nome: "",
        editalAberto: "",
      },
      errosHeaders: {
        nomeContato: "Nome",
        emailContato: "E-mail",
        telefoneContato: "Telefone",
        municipioId: "Municipio",
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    cadastrar() {
      this.avisos = [];
      Object.keys(this.payload).map((payload) => {
        if (
          !Array.isArray(this.payload[payload]) &&
          !this.payload[payload] &&
          this.payload[payload] < 0
        ) {
          this.erros.push(`Campo ${this.errosHeaders[payload]} é obrigatório`);
        }
      });

      if (this.avisos.length === 0) {
        this.setLoading(true);
        municipioAPI
          .update(this.payload)

          .then((resp) => {
            this.setLoading(false);
            this.$toast.success("Municipio atualizado");
            window.location.reload();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$toast.error("Erro ao atualizar");
          });
      } else {
        this.erros.forEach((item) => {
          this.$toast(item, {
            timeout: 2000,
            hideProgressBar: true,
            position: POSITION.BOTTOM_RIGHT,
            type: TYPE.ERROR,
          });
        });
      }
    },
    listarMunicipios() {
      municipioAPI
        .list()
        .then((resp) => {
          this.municipios = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    municipioChange() {
      let newMunicipio = this.municipios.filter(
        (item) => item.municipioId === this.payload.municipioId
      )[0];
      this.payload.emailContato = newMunicipio["emailContato"];
      this.payload.nome = newMunicipio["nome"];
      this.payload.editalAberto = newMunicipio["editalAberto"];
      this.payload.temEdital = newMunicipio["temEdital"];
      this.payload.nomeContato = newMunicipio["nomeContato"];
      this.payload.telefoneContato = newMunicipio["telefoneContato"];
    },
  },
  mounted() {
    this.listarMunicipios();
  },
};
</script>
